import React, { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate, Outlet } from 'react-router-dom';
import AdminSummary from '../components/AdminSummary';
import { canAccessAdmin, hasPermission, getToken } from '../services/authService';
import { AdminSocketProvider } from '../context/AdminSocketContext';
import { useCurrency } from '../context/CurrencyContext';
import API_BASE_URL from '../config';
import './Admin.css';
import AdminHeader from '../components/AdminHeader';

const SidebarIcon = ({ name, size = 18 }) => {
  const icons = {
    dashboard: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>,
    users: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>,
    blogs: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>,
    services: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>,
    products: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>,
    orders: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>,
    reports: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>,
    pages: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>,
    categories: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg>,
    settings: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1-2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>,
    media: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>,
    chat: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>,
    shops: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>,
    fushatat: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m3 11 18-5v12L3 13v-2z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/></svg>
  };
  return icons[name] || null;
};

export default function Admin() {
  const navigate = useNavigate();
  const canAdminAccess = canAccessAdmin();
  const canUsers = hasPermission('admin.users');
  const canBlogs = hasPermission('admin.blogs');
  const canServices = hasPermission('admin.services');
  const canProducts = hasPermission('admin.products');
  const canOrders = hasPermission('admin.orders');
  const canReports = hasPermission('admin.reports');
  const canPages = hasPermission('admin.pages');
  const canCategories = hasPermission('admin.categories');
  const canSettings = hasPermission('admin.settings');
  const canShops = hasPermission('admin.shops');

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    return localStorage.getItem('admin_sidebar_collapsed') === 'true';
  });

  useEffect(() => {
    if (!canAdminAccess) {
      navigate('/login');
    }
  }, [navigate, canAdminAccess]);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(prev => {
      const newState = !prev;
      localStorage.setItem('admin_sidebar_collapsed', String(newState));
      return newState;
    });
  };

  return (
    <div translate="no" className={`admin-layout ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <aside className={`admin-sidebar ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="admin-sidebar-header">
          {!isSidebarCollapsed && (
            <div className="admin-sidebar-title">
              <span className="sidebar-title-text">Admin Console</span>
            </div>
          )}
          <button className="sidebar-toggle" onClick={toggleSidebar} title={isSidebarCollapsed ? 'Expand' : 'Collapse'}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ transform: isSidebarCollapsed ? 'rotate(180deg)' : 'none', transition: 'transform 0.3s' }}>
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </button>
        </div>
        <nav className="admin-nav">
          <NavLink to="/admin" end className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`} title="Dashboard">
            <span className="nav-icon"><SidebarIcon name="dashboard" /></span>
            <span className="nav-text">Dashboard</span>
          </NavLink>
          {canUsers && (
            <NavLink to="/admin/users" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`} title="Users">
              <span className="nav-icon"><SidebarIcon name="users" /></span>
              <span className="nav-text">Users</span>
            </NavLink>
          )}
          {canBlogs && (
            <NavLink to="/admin/blogs" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`} title="Blogs">
              <span className="nav-icon"><SidebarIcon name="blogs" /></span>
              <span className="nav-text">Blogs</span>
            </NavLink>
          )}
          {canServices && (
            <NavLink to="/admin/services" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`} title="Services">
              <span className="nav-icon"><SidebarIcon name="services" /></span>
              <span className="nav-text">Services</span>
            </NavLink>
          )}
          {canProducts && (
            <NavLink to="/admin/products" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`} title="Products">
              <span className="nav-icon"><SidebarIcon name="products" /></span>
              <span className="nav-text">Products</span>
            </NavLink>
          )}
          {canOrders && (
            <NavLink to="/admin/orders" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`} title="Orders">
              <span className="nav-icon"><SidebarIcon name="orders" /></span>
              <span className="nav-text">Orders</span>
            </NavLink>
          )}
          {canReports && (
            <NavLink to="/admin/reports" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`} title="Reports">
              <span className="nav-icon"><SidebarIcon name="reports" /></span>
              <span className="nav-text">Reports</span>
            </NavLink>
          )}
          {canShops && (
            <NavLink to="/admin/shops" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`} title="Shops Locations">
              <span className="nav-icon"><SidebarIcon name="shops" /></span>
              <span className="nav-text">Shops Locations</span>
            </NavLink>
          )}
          {canPages && (
            <NavLink to="/admin/pages" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`} title="Pages">
              <span className="nav-icon"><SidebarIcon name="pages" /></span>
              <span className="nav-text">Pages</span>
            </NavLink>
          )}
          {canPages && (
            <NavLink to="/admin/media" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`} title="Media & Files">
              <span className="nav-icon"><SidebarIcon name="media" /></span>
              <span className="nav-text">Media & Files</span>
            </NavLink>
          )}
          <NavLink to="/admin/chat" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`} title="Chat Support">
            <span className="nav-icon"><SidebarIcon name="chat" /></span>
            <span className="nav-text">Chat Support</span>
          </NavLink>
          {canCategories && (
            <NavLink to="/admin/categories" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`} title="Categories">
              <span className="nav-icon"><SidebarIcon name="categories" /></span>
              <span className="nav-text">Categories</span>
            </NavLink>
          )}
          {canSettings && (
            <NavLink to="/admin/fushatat" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`} title="Fushatat">
              <span className="nav-icon"><SidebarIcon name="fushatat" /></span>
              <span className="nav-text">Fushatat</span>
            </NavLink>
          )}
          {canSettings && (
            <NavLink to="/admin/settings" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`} title="Settings">
              <span className="nav-icon"><SidebarIcon name="settings" /></span>
              <span className="nav-text">Settings</span>
            </NavLink>
          )}
        </nav>
        {!isSidebarCollapsed && (
          <div className="admin-sidebar-footer">
            <div style={{ marginBottom: 6 }}><strong>Tips</strong></div>
            <div>Use the sidebar to navigate management sections.</div>
          </div>
        )}
      </aside>

      <main className="admin-main">
        <AdminHeader />
        <div className="admin-content">
          <AdminSocketProvider>
            <Outlet />
          </AdminSocketProvider>
        </div>
      </main>
    </div>
  );
}

// default content for the /admin index route
export function AdminHome() {
  const canUsers = hasPermission('admin.users');
  const canOrders = hasPermission('admin.orders');
  const canProducts = hasPermission('admin.products');
  const canPages = hasPermission('admin.pages');
  const canSettings = hasPermission('admin.settings');

  const { formatPrice } = useCurrency();

  const [recentUsers, setRecentUsers] = useState([]);
  const [recentOrders, setRecentOrders] = useState([]);
  const [topProducts, setTopProducts] = useState([]);
  const [syncStatus, setSyncStatus] = useState({});
  const [counts, setCounts] = useState({ products: 0, pages: 0, blogs: 0 });

  useEffect(() => {
    const token = getToken();
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    if (canUsers) {
      fetch(`${API_BASE_URL}/users`, { headers })
        .then(r => r.json())
        .then(data => {
          let list = Array.isArray(data) ? data : (data.users || []);
          if (list.length > 0) {
            setRecentUsers(list.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).slice(0, 5));
          }
        }).catch(e => console.error(e));
    }

    if (canOrders) {
      fetch(`${API_BASE_URL}/orders`, { headers })
        .then(r => r.json())
        .then(data => {
          let list = Array.isArray(data) ? data : (data.orders || []);
          if (list.length > 0) {
            setRecentOrders([...list].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).slice(0, 5));
          }
        }).catch(e => console.error(e));

      fetch(`${API_BASE_URL}/orders/top-products?limit=5`, { headers })
        .then(r => r.json())
        .then(data => {
          if (Array.isArray(data)) setTopProducts(data);
        }).catch(e => console.error(e));
    }

    if (canSettings) {
      fetch(`${API_BASE_URL}/settings/all`, { headers })
        .then(r => r.json())
        .then(data => {
          if (data) {
            setSyncStatus({
              globe: data.globe_last_sync_at,
            });
          }
        }).catch(e => console.error(e));
    }

    // Fetch counts for other entities
    fetch(`${API_BASE_URL}/products`, { headers })
      .then(r => r.json())
      .then(data => setCounts(prev => ({ ...prev, products: Array.isArray(data) ? data.length : (data.total || 0) })))
      .catch(e => console.error(e));

    fetch(`${API_BASE_URL}/pages`, { headers })
      .then(r => r.json())
      .then(data => setCounts(prev => ({ ...prev, pages: Array.isArray(data) ? data.length : 0 })))
      .catch(e => console.error(e));

    fetch(`${API_BASE_URL}/blogs`, { headers })
      .then(r => r.json())
      .then(data => setCounts(prev => ({ ...prev, blogs: Array.isArray(data) ? data.length : 0 })))
      .catch(e => console.error(e));
  }, [canUsers, canOrders, canSettings]);

  const menuCards = [
    {
      title: 'Users',
      path: '/admin/users',
      icon: 'users',
      show: canUsers,
      color: '#3b82f6',
      bg: '#eff6ff'
    },
    {
      title: 'Orders',
      path: '/admin/orders',
      icon: 'orders',
      show: canOrders,
      color: '#f59e0b',
      bg: '#fffbeb'
    },
    {
      title: 'Products',
      path: '/admin/products',
      icon: 'products',
      show: canProducts,
      color: '#10b981',
      bg: '#ecfdf5'
    },
    {
      title: 'Pages',
      path: '/admin/pages',
      icon: 'pages',
      show: canPages,
      color: '#6366f1',
      bg: '#eef2ff'
    },
    {
      title: 'Footer',
      path: '/admin/footer',
      icon: 'settings',
      show: canSettings,
      color: '#8b5cf6',
      bg: '#f5f3ff'
    }
  ];

  const formatDate = (isoString) => {
    if (!isoString) return 'Never';
    return new Date(isoString).toLocaleString();
  };

  return (
    <div className="admin-dashboard-wrapper">
      <div className="admin-summary-section" style={{ marginTop: '0px' }}>
        <div className="admin-summary-container">
          <AdminSummary days={14} />
        </div>
      </div>

      <div className="admin-quick-links-section">
        <div className="admin-quick-links-grid">
          {menuCards.filter(c => c.show).map(card => (
            <Link key={card.title} to={card.path} className="admin-quick-link-card">
              <div className="quick-link-icon-wrapper" style={{ backgroundColor: card.bg, color: card.color }}>
                <SidebarIcon name={card.icon} size={24} />
              </div>
              <div className="quick-link-content">
                <h3>{card.title}</h3>
                <span className="quick-link-arrow">→</span>
              </div>
            </Link>
          ))}

          <div className="admin-inline-stats">
            <div className="inline-stat">
              <span className="stat-value">{counts.products}</span>
              <span className="stat-label">Products</span>
            </div>
            <div className="inline-stat">
              <span className="stat-value">{counts.pages}</span>
              <span className="stat-label">Pages</span>
            </div>
            <div className="inline-stat">
              <span className="stat-value">{counts.blogs}</span>
              <span className="stat-label">Blogs</span>
            </div>
          </div>
        </div>
      </div>

      <div className="admin-dashboard-details-grid">
        {canOrders && (
          <div className="admin-dashboard-panel">
            <div className="panel-header">
              <h3>Latest Orders</h3>
              <Link to="/admin/orders" className="panel-link">View All</Link>
            </div>
            {recentOrders.length === 0 ? (
              <p className="panel-empty">No orders found.</p>
            ) : (
              <div className="panel-list">
                {recentOrders.map(o => (
                  <div key={o.id} className="panel-list-item">
                    <div className="item-main">
                      <strong>Order #{o.id}</strong>
                      <span className={`status-badge status-${o.status?.toLowerCase() || 'pending'}`}>
                        {o.status || 'Pending'}
                      </span>
                    </div>
                    <div className="item-sub">
                      <span>{o.email || o.orderEmail}</span>
                      <span style={{ fontWeight: 600, color: '#0f172a' }}>{formatPrice(o.total || 0)}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {canUsers && (
          <div className="admin-dashboard-panel">
            <div className="panel-header">
              <h3>Latest Users</h3>
              <Link to="/admin/users" className="panel-link">View All</Link>
            </div>
            {recentUsers.length === 0 ? (
              <p className="panel-empty">No users found.</p>
            ) : (
              <div className="panel-list">
                {recentUsers.map(u => (
                  <div key={u.id} className="panel-list-item user-item">
                    <div className="item-main">
                      <strong>{u.name} {u.surname || ''}</strong>
                      <span className="user-role-badge">{u.role}</span>
                    </div>
                    <div className="item-sub">
                      <span>{u.email}</span>
                      <span>{new Date(u.createdAt).toLocaleDateString()}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {canOrders && (
          <div className="admin-dashboard-panel">
            <div className="panel-header">
              <h3>Top Selling Products</h3>
              <Link to="/admin/products" className="panel-link">Manage</Link>
            </div>
            {topProducts.length === 0 ? (
              <p className="panel-empty">No products sold yet.</p>
            ) : (
              <div className="panel-list">
                {topProducts.map(p => (
                  <div key={p.productId} className="panel-list-item">
                    <div className="item-main" style={{ justifyContent: 'flex-start', gap: '12px' }}>
                      {p.product?.image && (
                        <img src={p.product.image} alt={p.product?.name || 'Product'} style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4 }} />
                      )}
                      <div>
                        <strong>{p.product?.name || 'Unknown Product'}</strong>
                      </div>
                    </div>
                    <div className="item-sub">
                      <span>Sold: {p.qty}</span>
                      <span style={{ fontWeight: 600, color: '#0f172a' }}>{formatPrice(p.revenue)}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {canSettings && (
          <div className="admin-dashboard-panel sync-panel">
            <div className="panel-header">
              <h3>Background Sync Status</h3>
              <Link to="/admin/settings" className="panel-link">Settings</Link>
            </div>
            <div className="panel-list">
              <div className="panel-list-item sync-item">
                <div className="item-main">
                  <strong>Globe Products API Import</strong>
                </div>
                <div className="item-sub">Last updated: {formatDate(syncStatus.globe)}</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

